import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { ZorroQuestionmarkIcon } from '@zorro/shared/assets';
import { Box, Group, Text, brand } from '@zorro/web/design-system';

export const PENDING_ELECTION_LABEL = 'Pending election';

export const PendingElection = () => {
  return (
    <Group gap="0.25rem">
      <Text size="sm">{PENDING_ELECTION_LABEL}</Text>
      <Tooltip
        label="The expected start date will be calculated and displayed here once the employee submits their election"
        position="top"
      >
        <Box>
          <ZorroQuestionmarkIcon color={brand.zorroGray400} />
        </Box>
      </Tooltip>
    </Group>
  );
};
